import { BaseDashboardActionItem } from '@uplift/ui-v2';
import React from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { practiceStateSetupRoute } from '@uplift/constants';
import { useStatesQuery } from '@uplift/queries';


type StartGoLiveProps = {
  stateId: string;
};


export const StartGoLive: React.VFC<StartGoLiveProps> = ({ stateId }) => {
  const history = useHistory();
  const { data: states = [] } = useStatesQuery();
  const stateName = states.find(state => state.id === stateId)?.fullName ?? '';

  return (
    <BaseDashboardActionItem
      title={<Typography>Go live in <b>{stateName}</b></Typography>}
      body={(
        <Typography variant="body2" sx={{ mt: -1 }}>
          Complete your requirements to start seeing patients in {stateName}.
        </Typography>
      )}
      color="info"
      icon={<ArrowForward />}
      action={{
        handleClick: () => {
          history.push(practiceStateSetupRoute.createLink({ stateId }));
        },
        text: 'Get Started'
      }}
    />
  );
};
